module.exports = __webpack_public_path__ + "img/proxima-negative-without-symptons.491a82e5.png";